import React, { memo, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { Button, Modal, Spin, Progress, Row, Col } from 'antd';
import { awaitWrapper } from '@utils/helper';
import { makeSelectUser } from '@/global.selectors';
import request from '@utils/request';
import { selectList, selectLoading } from '../selectors';
import { getProductAction, postProductAction } from '../actions';


class UpdateProduct extends PureComponent {
  constructor() {
    super();
    this.state = {
      showModal: false,
      isProcessing: false,
      dataList: [],
      currentProcessIndex: 0,
    }
    this.currentProcessIndex = 0;
    this.tDoUpdateProduct = null;
  }
  handleOpenModal = () => {
    this.setState({ showModal: true });
    if(!this.props.singleMode){
      this.props.getList();
    } 
  }
  handleUpdateProduct = () => {
    if (this.state.isProcessing) {
      this.setState({ isProcessing: false });
    } else {
      this.setState({ isProcessing: true });
      this.currentProcessIndex = 0;
      const dataList = this.props.list.filter(x => !x.id);
      this.setState({ dataList, currentProcessIndex: 0 }, () => this.doUpdateProduct());
    }

  }
  doUpdateProduct = async () => {
    if (!this.state.isProcessing || this.currentProcessIndex >= this.state.dataList.length) {
      this.setState({ isProcessing: false });
      return;
    }
    const item = this.getCurrentItem();// this.state.dataList[this.currentProcessIndex];
    const sapoProductId = parseInt(item.pId, 0);
    const [err, result] = await awaitWrapper(request.get(`/v1/product-meta/sapo-product/${sapoProductId}`));
    if(result.data){
      const images = result.data.product.images;
      if(images.length){
        const image = images[0].full_path;
        const galleryArr = images.slice(1);
        let gallery = '';
        if(galleryArr.length){
          gallery = galleryArr.map(x => x.full_path).join((','));
        }
        const categoryId = 10;
        const productCategories = ';10;';
        const updateData = {
          productId: item.pId,
          sku: item.pSku.toUpperCase(),
          wooProductId: 0,
          image,
          gallery,
          categoryId,
          productCategories
        }
        this.props.updateProduct(updateData);
      }
    }
    clearTimeout(this.tDoUpdateProduct);
    this.currentProcessIndex += 1;
    if (!this.props.singleMode && this.currentProcessIndex < this.state.dataList.length) {
      this.tDoUpdateProduct = setTimeout(() => { this.doUpdateProduct(); }, 500);
      this.setState({ currentProcessIndex: this.currentProcessIndex });
    } else {
      this.setState({
        isProcessing: false
      });
    }

    return;
  }
  getCurrentItem = () => {
    if(this.props.singleMode) return this.props.item;
    return this.state.dataList[this.state.currentProcessIndex] || {};
  }
  render() {
    if (this.props.user.role > 1) return '';
    const { showModal, isProcessing } = this.state;
    const { loading } = this.props;
    const currentItem = this.getCurrentItem();
    const progress = isProcessing ? Math.round(((this.state.currentProcessIndex + 1) / this.state.dataList.length) * 100) : 0;
    const title = `Cập nhật sản phẩm: ${currentItem.pName || ''}`;
    return (
      <>
        {this.props.singleMode ? <Button title="Update Product" icon="cloud-upload" onClick={this.handleOpenModal} /> :<Button onClick={this.handleOpenModal}>Cập nhật Sản Phẩm</Button>}
        {showModal &&
          <Modal width="40%" title={title} visible onCancel={() => this.setState({ showModal: false })} footer={null}>
            <Spin spinning={loading}>
              <Row>
                <Col sm={24}>
                  <Progress percent={progress} />
                </Col>
              </Row>
              <Row>
                <Col sm={24}>
                  <Button disabled={this.props.loading} onClick={this.handleUpdateProduct} type="primary">{isProcessing ? 'Stop' : 'Start'}</Button>
                </Col>
              </Row>
              {isProcessing && <Row>
                <Col sm={12}>Updating: {currentItem.pName}</Col>
              </Row>}
            </Spin>
          </Modal>}
      </>
    );
  }
}

UpdateProduct.propTypes = {
  list: PropTypes.array,
  loading: PropTypes.bool,
  singleMode: PropTypes.bool,
  item: PropTypes.object
};

UpdateProduct.defaultProps = {
  list: [],
  loading: false,
  singleMode: false,
  item: {},
};

const mapStateToProps = createStructuredSelector({
  list: selectList(),
  loading: selectLoading(),
  user: makeSelectUser(),
});

const mapDispatchToProps = dispatch => ({
  getList: () => dispatch(getProductAction()),
  updateProduct: data => dispatch(postProductAction(data)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(UpdateProduct);
